import './index.scss';
import './components/Slider';
import './components/layouts/Header';
import './components/buttons.scss';
import './components/Title.scss';
import './components/section.scss';
import './components/FixedR';
import './components/SectionSingleGame'; // tween max ie
import './components/SectionOurGames'; // tween max ie
import './components/SectionMetrics'; // tween max ie
import './components/SectionCareers';
import './components/SectionSocial';
import './components/SectionNews';
import './components/SectionNewsCard';
import './components/SectionNewsOne';
import './components/SectionPlayNow';
import './components/SectionGameoneSlider';
import './components/SectionCharacters';
import './components/SectionCareersSlider';
import './components/SectionCareersCards';
import './components/SectionAboutCareers';
import './components/SectionContact';
import './components/SectionHero'; // tween max ie
import './components/layouts/Footer';
import './components/BlockThinText';
import './components/Error404';
import './components/Preloader';
